module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "lis"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#lis"
    }
  }, [_vm._v("ILLUSTRATIONS AND TABLES")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_c('i', [_vm._v("Illustrations")])]), _vm._v(" "), _c('table', {
    staticClass: "Table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "fig_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 1.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_vm._v("The Ear in Land Mammals and Whales, Figure 41 from J. G. M. “Hans” Thewissen, "), _c('i', [_vm._v("The Walking Whales")]), _vm._v(" © University of California Press")])])])]), _vm._v(" "), _c('table', {
    staticClass: "Table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "plate-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#plate_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 1.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_vm._v("The Ancient Hebrew Conception of the Universe © Michael Paukner")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "plate-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#plate_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 2.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_c('i', [_vm._v("Pakicetus")]), _vm._v(" © Roman Uchytel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "plate-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#plate_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 3.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_c('i', [_vm._v("Ambulocetus natans")]), _vm._v(" © Roman Uchytel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "plate-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#plate_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 4.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_c('i', [_vm._v("Kutchicetus")]), _vm._v(" © Roman Uchytel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "plate-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#plate_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 5.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_c('i', [_vm._v("Maiacetus")]), _vm._v(" © Roman Uchytel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "plate-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#plate_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 6.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_c('i', [_vm._v("Basilosaurus")]), _vm._v(" © Roman Uchytel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "plate-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#plate_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 7.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_vm._v("Lucy © Elisabeth Daynes / LookatSciences")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "plate-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#plate_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 8.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_c('i', [_vm._v("Homo erectus")]), _vm._v(" © S. Entressangle, E. Daynes / LookatSciences")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "plate-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#plate_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 9.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_c('i', [_vm._v("Homo neanderthalensis")]), _vm._v(" © Elisabeth Daynes / LookatSciences")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "plate-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#plate_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 10.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_c('i', [_vm._v("Homo floresiensis")]), _vm._v(" © Elisabeth Daynes / LookatSciences")])])])]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("Tables")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('table', {
    staticClass: "Table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "tab-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#tab_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 1.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_vm._v("Resemblances between Genesis and Other Ancient Flood Stories")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "tab-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#tab_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 2.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_vm._v("Comparison of Genesis 5 in Different Textual Traditions")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft-r",
    attrs: {
      "id": "tab-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#tab_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 3.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdlefta"
  }, [_vm._v("Comparison of 4QEnc, Greek Fragments, and Jude")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be3f3abe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illustrations.vue
// module id = 72
// module chunks = 0